module.exports = __webpack_public_path__ + "img/customized.ab8f42bc.jpg";